const initState = {
  hash: '',
  hashError: null,
  messageEmail: null,
  messageEmailError: null,
};

const socialShareReducer = (state = initState, action) => {
  switch (action.type) {
    case 'GET_SHARE_LINK_ERROR':
      return {
        ...state,
        hashError: action.data,
      };
    case 'GET_SHARE_LINK_SUCCESS':
      return {
        ...state,
        hash: action.data,
        hashError: null,
      };
    case 'GET_SHARE_EMAIL_ERROR':
      return {
        ...state,
        messageEmailError: action.data,
      };
    case 'GET_SHARE_EMAIL_SUCCESS':
      return {
        ...state,
        messageEmail: action.data,
        messageEmailError: null,
      };

    default:
      return state;
  }
};

export default socialShareReducer;
